export default (i18n, i18nService) => {
    return {
        namespaced: true,
        state: {
            overrides: [],
        },
        mutations: {
            applyLocale(state, {locale, primevue}){
                const override = state.overrides[locale]
                i18n.global.locale = locale
                i18n.global.mergeLocaleMessage(locale, override)
                primevue.config.locale = i18n.global.messages[locale].primevue
            }
        },
        actions: {
            async changeLocal(context, {locale, primevue}){
                let override = context.state.overrides[locale]
                if(!override){
                    console.info('Loading i18n override for', locale)
                    override = await i18nService.getI18nOverride(locale)
                    context.state.overrides[locale] = override
                }
                context.commit('applyLocale', {locale, primevue})
            }
        }
    }
}
